(() => {
  const STORAGE_KEY = 'lcg-wishlist-v1';

  const countItems = () => {
    try {
      const items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(items) ? items.length : 0;
    } catch (error) {
      return 0;
    }
  };

  const syncCount = () => {
    const count = countItems();
    const hasItems = count > 0;
    document.querySelectorAll('[data-lcg-wishlist]').forEach((trigger) => {
      const badge = trigger.querySelector('[data-lcg-wishlist-count]');
      trigger.classList.toggle('has-items', hasItems);
      trigger.setAttribute(
        'aria-label',
        hasItems ? `Favoris, ${count}${window.CabaneI18n.pick(" produit"," product")}${count > 1 ? 's' : ''}` : window.CabaneI18n.pick("Favoris","wishlist")
      );
      if (badge) {
        badge.textContent = count > 99 ? '99+' : String(count);
        badge.hidden = !hasItems;
      }
    });
  };

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-lcg-wishlist]')) return;
    event.preventDefault();
    document.dispatchEvent(new CustomEvent('lcg:wishlist-open'));
  });
  document.addEventListener('lcg:wishlist-change', syncCount);
  document.addEventListener('shopify:section:load', syncCount);
  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) syncCount();
  });
  syncCount();
})();

(() => {
  if (window.__lcgChatVisibilityController) {
    window.__lcgChatVisibilityController.refresh();
    return;
  }

  const MOBILE_QUERY = '(max-width: 749px)';
  const SENSITIVE_SELECTOR = '#categories, [data-cabane-catalog-root] #product-grid';
  const BUYBAR_SELECTOR = 'body.template-product [data-cabane-mobile-buybar]';
  const ROOT_CLASS = 'lcg-chat-sensitive';
  const mobileMedia = window.matchMedia(MOBILE_QUERY);
  const root = document.documentElement;
  let intersectionObserver;
  let contentObserver;
  let buybarObserver;
  let frameId;

  const intersectsViewport = (element) => {
    const bounds = element.getBoundingClientRect();
    return bounds.width > 0
      && bounds.height > 0
      && bounds.bottom > 0
      && bounds.right > 0
      && bounds.top < window.innerHeight
      && bounds.left < window.innerWidth;
  };

  const update = () => {
    frameId = undefined;

    if (!mobileMedia.matches) {
      root.classList.remove(ROOT_CLASS);
      return;
    }

    const hasSensitiveContent = Array.from(document.querySelectorAll(SENSITIVE_SELECTOR)).some(intersectsViewport);
    const hasActiveBuybar = Array.from(document.querySelectorAll(BUYBAR_SELECTOR)).some(
      (buybar) => buybar.getAttribute('aria-hidden') !== 'true'
    );

    root.classList.toggle(ROOT_CLASS, hasSensitiveContent || hasActiveBuybar);
  };

  const scheduleUpdate = () => {
    if (frameId !== undefined) return;
    frameId = window.requestAnimationFrame(update);
  };

  const watchBuybars = () => {
    buybarObserver?.disconnect();
    buybarObserver = new MutationObserver(scheduleUpdate);
    document.querySelectorAll(BUYBAR_SELECTOR).forEach((buybar) => {
      buybarObserver.observe(buybar, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'class', 'hidden']
      });
    });
  };

  const refresh = () => {
    intersectionObserver?.disconnect();

    if (mobileMedia.matches && 'IntersectionObserver' in window) {
      intersectionObserver = new IntersectionObserver(scheduleUpdate, { threshold: 0 });
      document.querySelectorAll(SENSITIVE_SELECTOR).forEach((element) => intersectionObserver.observe(element));
    }

    watchBuybars();
    scheduleUpdate();
  };

  const start = () => {
    refresh();
    // Only rebuild observers when their targets enter or leave the DOM.
    // Product swatches, price text and menu changes do not change these targets.
    let refreshFrame;
    const targets = `${SENSITIVE_SELECTOR}, ${BUYBAR_SELECTOR}`;
    const containsTarget = node => node.nodeType === 1 && (node.matches(targets) || node.querySelector(targets));
    contentObserver = new MutationObserver(records => {
      if (refreshFrame !== undefined || !records.some(record =>
        [...record.addedNodes, ...record.removedNodes].some(containsTarget))) return;
      refreshFrame = requestAnimationFrame(() => { refreshFrame = undefined; refresh(); });
    });
    contentObserver.observe(document.body, { childList: true, subtree: true });
  };

  window.__lcgChatVisibilityController = { refresh };

  if (typeof mobileMedia.addEventListener === 'function') {
    mobileMedia.addEventListener('change', refresh);
  } else {
    mobileMedia.addListener(refresh);
  }
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
/* Language selector: styled disclosure, retaining the native localization form. */
(()=>{
 const init=()=>document.querySelectorAll('.lcg-header__locale').forEach(wrapper=>{
  const select=wrapper.querySelector('select');if(!select||wrapper.querySelector('.lcg-language-toggle'))return;
  const toggle=document.createElement('button');toggle.type='button';toggle.className='lcg-language-toggle';toggle.setAttribute('aria-label',select.getAttribute('aria-label')||'Langue');toggle.setAttribute('aria-expanded','false');
  for(const node of [...wrapper.children])if(node!==select)toggle.append(node);
  const panel=document.createElement('div');panel.className='lcg-language-options';panel.id=select.id+'-options';panel.hidden=true;toggle.setAttribute('aria-controls',panel.id);
  const close=(focus=false)=>{panel.hidden=true;toggle.setAttribute('aria-expanded','false');if(focus)toggle.focus()};
  for(const option of select.options){const button=document.createElement('button');button.type='button';button.lang=option.lang||option.value;button.textContent=option.textContent.trim();button.setAttribute('aria-pressed',String(option.selected));button.addEventListener('click',()=>{close();if(select.value!==option.value){select.value=option.value;if(window.__cabaneLocal){const url=new URL(location.href);const path=url.pathname.replace(/^\/en(?=\/|$)/,'')||'/';url.pathname=option.value==='en'?'/en'+path:path;location.assign(url.href);}else{select.dispatchEvent(new Event('change',{bubbles:true}));}}});panel.append(button)}
  select.hidden=true;select.tabIndex=-1;wrapper.append(toggle,panel);
  toggle.addEventListener('click',()=>{panel.hidden=!panel.hidden;toggle.setAttribute('aria-expanded',String(!panel.hidden))});
  toggle.addEventListener('keydown',event=>{if(event.key==='ArrowDown'){event.preventDefault();panel.hidden=false;toggle.setAttribute('aria-expanded','true');panel.querySelector('button').focus()}});
  wrapper.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();close(true)}});
  wrapper.addEventListener('focusout',()=>setTimeout(()=>{if(!wrapper.contains(document.activeElement))close()},0));
  document.addEventListener('pointerdown',event=>{if(!wrapper.contains(event.target))close()});
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);
})();
/* Mobile locale belongs beneath the menu social links; keep one native form. */
(() => {
  const mobile = matchMedia('(max-width: 1023px)');
  const init = () => document.querySelectorAll('.lcg-header').forEach(header => {
    const form = header.querySelector('.lcg-header__locale-form');
    const footer = header.querySelector('.lcg-catalog__mobile-footer');
    const tools = header.querySelector('.lcg-header__tools');
    if (!form || !footer || !tools || form.dataset.mobilePlacement) return;
    form.dataset.mobilePlacement = 'true';
    const marker = document.createComment('desktop language position');
    form.before(marker);
    const place = () => {
      const panel = form.querySelector('.lcg-language-options');
      if (panel) panel.hidden = true;
      const toggle = form.querySelector('.lcg-language-toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (mobile.matches) footer.append(form); else marker.after(form);
      const label = toggle?.querySelector('span');
      const select = form.querySelector('select');
      if (label && select) label.textContent = mobile.matches ? select.selectedOptions[0].textContent.trim() : select.value.toUpperCase();
    };
    place();
    mobile.addEventListener('change', place);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();/* A short mobile search prompt fits without truncation. */
(() => {
 const mobile=matchMedia('(max-width:1023px)');
 const init=()=>document.querySelectorAll('.lcg-header__search .lcg-search-trigger__label').forEach(label=>{
  if(label.dataset.mobilePrompt)return;
  label.dataset.mobilePrompt=label.textContent;
  const update=()=>{label.textContent=mobile.matches?(document.documentElement.lang.startsWith('fr')?'Rechercher un produit':'Search products'):label.dataset.mobilePrompt};
  update();mobile.addEventListener('change',update);
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();
/* Fit the mobile welcome banner to the space above the six category cards. */
(() => {
 const init=()=>{
  if(!document.body.classList.contains('template-index'))return;
  const hero=document.querySelector('.lcg-hero--split');
  const categories=document.querySelector('.lcg-category-matrix');
  if(!hero||!categories||hero.dataset.firstScreenReady)return;
  hero.dataset.firstScreenReady='true';
  let frame=0;
  const fit=()=>{
   frame=0;
   if(!matchMedia('(max-width:749px)').matches){hero.style.removeProperty('--cabane-home-hero-height');return;}
   if(document.activeElement?.matches('input,textarea'))return;
   const cards=[...categories.querySelectorAll('.lcg-category-matrix__card')];
   if(cards.length!==6)return;
   const bottom=Math.max(...cards.map(card=>card.getBoundingClientRect().bottom))+scrollY;
   const height=Math.max(170,Math.round(innerHeight-(bottom-hero.getBoundingClientRect().height)-6));
   hero.style.setProperty('--cabane-home-hero-height',height+'px');
  };
  const schedule=()=>{if(!frame)frame=requestAnimationFrame(fit)};
  const observer=new ResizeObserver(schedule);observer.observe(categories);
  const header=document.querySelector('.lcg-header');if(header)observer.observe(header);
  window.addEventListener('resize',schedule,{passive:true});
  document.fonts?.ready.then(schedule);schedule();
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();